import { render, staticRenderFns } from "./FieldType22Configure.vue?vue&type=template&id=0185a212&scoped=true"
import script from "./FieldType22Configure.vue?vue&type=script&lang=js"
export * from "./FieldType22Configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0185a212",
  null
  
)

export default component.exports